"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookUp = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let LookUp = class LookUp {
    constructor(id, lookUpKey, lookUpName, lookUpValueKey, lookUpValue, description, lookUpOrder, createdAt, updatedAt, createdBy, updatedBy) {
        this.id = id;
        this.lookUpKey = lookUpKey;
        this.lookUpName = lookUpName;
        this.lookUpValueKey = lookUpValueKey;
        this.lookUpValue = lookUpValue;
        this.description = description;
        this.lookUpOrder = lookUpOrder;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.LookUp = LookUp;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], LookUp.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "lookup_key", type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], LookUp.prototype, "lookUpKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "lookup_name", type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], LookUp.prototype, "lookUpName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "value_key", type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], LookUp.prototype, "lookUpValueKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "value", type: "text" }),
    tslib_1.__metadata("design:type", String)
], LookUp.prototype, "lookUpValue", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "description", type: "text" }),
    tslib_1.__metadata("design:type", String)
], LookUp.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "lookup_order", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], LookUp.prototype, "lookUpOrder", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], LookUp.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], LookUp.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], LookUp.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], LookUp.prototype, "updatedBy", void 0);
exports.LookUp = LookUp = tslib_1.__decorate([
    (0, typeorm_1.Entity)("lookup_data"),
    tslib_1.__metadata("design:paramtypes", [Number, String, String, String, String, String, Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, String, String])
], LookUp);
